import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable, forkJoin, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { OrganizationPart } from './organization-part.model';
import Env from '@ridango/core/env';

@Injectable()
export class OrganizationPartService {
    constructor(
        @Inject('ENV') private env: Env,
        private http: HttpClient
    ) {}

    fetchOrganizationParts(organizationId: number): Observable<OrganizationPart[]> {
        const url = `${this.env.WMB.WMB_PUBLIC_API}/v1/organization/organization-part/${organizationId}`;
        return this.http.get<OrganizationPart[]>(url);
    }

    fetchOrganizationPartById(organizationPartId: number): Observable<OrganizationPart> {
        const url = `${this.env.WMB.WMB_PUBLIC_API}/v1/organization/organization-part/${organizationPartId}`;
        return this.http.get<OrganizationPart>(url);
    }

    fetchOrganizationPartsByIds(organizationPartIds: number[]): Observable<OrganizationPart[]> {
        if (!organizationPartIds || organizationPartIds.length === 0) {
            return of([]);
        }
        const uniqueIds = [...new Set(organizationPartIds)];
        const requests = uniqueIds.map((id) => this.fetchOrganizationPartById(id));
        return forkJoin(requests).pipe(map((parts) => parts.filter((part) => part !== null)));
    }
}
